export interface BaseInputProps {
	pointer: string;
	label?: string;
	placeholder?: string;
}

export interface FormFieldGroupProps extends Omit<BaseInputProps, 'label'> {
	uiSchema?: any;
}

export enum InputTypes {
	input = 'input',
	hidden = 'hidden',
	password = 'password',
}

export interface FormRawInputProps extends BaseInputProps {
	inputType?: InputTypes;
	value?: string;
}
